import React, { useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie';
import dateSetting from '../../utils/dateSetting';
import axios from 'axios';
import _ from 'lodash';
import Switch from "react-switch";
import DefaultLoader from '../../components/loader/DefaultLoader';
import ballCodeQuantile from '../../utils/record/ballCodeQuantile.json';
import *  as d3 from 'd3';
import ballObj from '../../utils/ball/ballObj';

function MovementProfile({profile, leagueTypeCodes = 'KBO'}) {
    const [cookies] = useCookies(['hiball_token']);
    const [recordObj, setRecordObj] = useState({pitchDataArr: [], sortedArr: [], ellipseDataArr: [], avgDataArr: []})
    const [toggle, setToggle] = useState(true);
    const [avgToggle, setAvgToggle] = useState(false);
    const [pitchToggle, setPitchToggle] = useState(true);
    const [loading, setLoading] = useState(false);
    const svgRef = useRef(null);

    const ballCodeObj = ballObj;

    useEffect(() => {
        let dateObj = dateSetting();
        let playerId = profile['playerId'];

        if(leagueTypeCodes === 'KBO') {
            let gameTypeCode = 4201;
            let params = {
                recordType: 'digestRecord', recordName: 'selectPitchLog',
                seasons: dateObj['season'],
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token']),
                pitcherIds: playerId,
            }

            let pbpPromise = new Promise((resolve, reject) => {
                axios({
                    url : `${process.env.REACT_APP_API_URL}`,
                    params
                }).then((result) => {
                    resolve(result);
                })
            });

            let pitchingHand = profile['pitchingHand'] === 'L' ? "Left" : "Right";

            let leaguePitchParam = {
                recordType: 'futuresRecordService', recordName: 'futuresPitcherTrackManRecord',
                seasons: dateObj['season'],
                groupingColumn: 'ballType',
                authToken:JSON.stringify(cookies['hiball_token']),
            }

            let leagueHandPitchPromise = new Promise((resolve, reject) => {
                axios({
                    url : `${process.env.REACT_APP_API_URL}`,
                    params: {
                        ...leaguePitchParam,
                        pitchingHands: pitchingHand,
                        gameTypeCode: gameTypeCode,
                    }
                }).then((result) => {
                    resolve(result);
                });
            });

            let pitchParam = {
                recordType: 'digestPitchingRecord', recordName: 'selectPitchBallCodeRecord',
                seasons: dateObj['season'],
                gameTypeCode: gameTypeCode,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
    
            let pitchPromise = new Promise((resolve, reject) => {
                axios({
                    url : `${process.env.REACT_APP_API_URL}`,
                    params: {
                        ...pitchParam,
                        pitcherIds: profile['playerId'],
                        gameTypeCode: gameTypeCode
                    }
                }).then((result) => {
                    resolve(result);
                });
            });
            
            Promise.all([
                pbpPromise, leagueHandPitchPromise, pitchPromise
            ]).then((response) => {
                setLoading(true);
                let record = _.shuffle(response[0]['data']['result']['ballList']);
                let pitchRecord = response[1]['data']['result'];
                let playerAvgRecord = response[2]['data']['result'];

                let indexedLeaguePitch = _.keyBy(pitchRecord, (item, idx) => {
                    if(item['taggedPitchType'] === 'Splitter') {
                        item['taggedPitchType'] = 'Forkball';
                    }

                    return item['taggedPitchType'];
                });
    
                let playerTotalCnt = 0;
                let indexedPlayerPitch = _.keyBy(playerAvgRecord, (item, idx) => {
                    playerTotalCnt += item['pitchCount']*1;
                    if(item['ballCode'] === 'Changeup') {
                        return 'ChangeUp';
                    } else if(item['ballCode'] === 'Two-Seamer(Sinker)') {
                        return 'Sinker';
                    } else if(item['taggedPitchType'] === 'Splitter') {
                        return 'Forkball'
                    } else {
                        return item['ballCode'];
                    }                    
                });                

                let filterRecord = _.filter(record, (item) => {
                    item['calcHorzBreak'] = (item['horzBreak'])*173/80;
                    item['calcInducedVertBreak'] = -(item['inducedVertBreak'])*173/80;
                    item['key'] = (item['gameInfoId']+"_"+item['batterId']+"_"+item['pitcherId']+"_"
                        +item['strikes']+"_"+item['balls']+"_"+item['inning']+"_"+item['outs']+"_"+item['pitchOfPa']);
                    
                    if(item['taggedPitchType'] === 'Splitter') {
                        item['taggedPitchType'] = 'Forkball';
                    }

                    if(item['taggedPitchType'] && item['horzBreak']) {
                        item['color'] = ballCodeObj[item['taggedPitchType']]['color'];
                        item['strokeColor'] = ballCodeObj[item['taggedPitchType']]['strokeColor'];
                    }

                    return item['taggedPitchType'] && item['horzBreak'];
                });

                let groupBall = _.groupBy(filterRecord, item => item['taggedPitchType']);

                let pitchInfoArr = [];
                let pitchDataArr = [];
                let ellipseDataArr = [];
                let avgDataArr = [];

                delete groupBall['Other'];

                _.each(groupBall, (item, idx) => {
                    let ballObj = ballCodeObj[idx];
                    let avgBallObj = indexedLeaguePitch[idx];
                    let playerAvgBallObj = indexedPlayerPitch[idx];
                    let avgQuantilData = _.find(ballCodeQuantile[pitchingHand], (item) => item['ballName'] == idx);
    
                    if(ballObj && playerAvgBallObj) {
                        let color = ballObj['color'];
                        let strokeColor = ballObj['strokeColor'];
                        let short = ballObj['short'];
                        let ballName = idx;
                        let pitchCnt = item['length'];
    
                        let avgHandTypeSpeed = avgBallObj['avgRelSpeed'];
                        let playerAvgSpeed = (playerAvgBallObj['ballSpeed']*1).toFixed(1);
                        let ballTypeCnt = playerAvgBallObj['pitchCount'];

                        let pitchRate = ((ballTypeCnt/playerTotalCnt)*100).toFixed(0);

                        let tmpObj = {
                            ballName, pitchCnt, color, pitchRate, strokeColor, short,
                            avgHandTypeSpeed, playerAvgSpeed
                        };

                        pitchInfoArr.push(tmpObj);

                        let originItem = _.clone(item);

                        if(toggle && (playerTotalCnt > 100)) {
                            item = item.slice(0, pitchRate);
                        }

                        if(pitchToggle) { // pitchByPitch
                            _.each(item, (innerData) => {
                                pitchDataArr.push(innerData);
                            });
                        } else { //eclipseData
                            let quantileObj = quantileFunc(originItem);
                            quantileObj['strokeColor'] = strokeColor;
                            quantileObj['color'] = color;

                            ellipseDataArr.push(quantileObj);
                        }

                        // let {horz_12, horz_87, induced_12, induced_87} = avgQuantilData;
                        let horz_12 = avgQuantilData['horz_12']*173/80;
                        let horz_87 = avgQuantilData['horz_87']*173/80;
                        let induced_12 = avgQuantilData['induced_12']*173/80;
                        let induced_87 = avgQuantilData['induced_87']*173/80;

                        let horzMiddle = ((horz_12 + horz_87)/2).toFixed(1);
                        let inducedMiddle = ((induced_12 + induced_87)/2).toFixed(1);

                        avgQuantilData['color'] = color;
                        avgQuantilData['strokeColor'] = strokeColor;
                        avgQuantilData['horzMiddle'] = horzMiddle;
                        avgQuantilData['inducedMiddle'] = inducedMiddle;

                        avgDataArr.push(avgQuantilData);
                    }
                });

                let sortedPitchArr = _.sortBy(pitchInfoArr, 'pitchCnt').reverse().slice(0, 5);

                setRecordObj((prevState) => {
                    return {
                        ...prevState,
                        sortedArr: sortedPitchArr,
                        pitchDataArr: pitchDataArr,
                        ellipseDataArr: ellipseDataArr,
                        avgDataArr: avgDataArr
                    }
                })
            });
        } else {
            let gameTypeCode = 4206;
            let trackmanPromise = new Promise((resolve, reject) => {
                axios({
                    url : `${process.env.REACT_APP_API_URL}`,
                    params: {
                        recordType: 'futuresRecordService',
                        recordName: 'futuresTrackManLogRecord',
                        seasons: dateObj['season'],
                        pitcherIds: playerId,
                        authToken: JSON.stringify(cookies['hiball_token']),
                        leagueTypeCodes
                    }
                }).then((result) => {
                    resolve(result);
                });
            })
    
            let pitchingHand = profile['pitchingHand'] === 'L' ? "Left" : "Right";
    
            let pitchParam = {
                recordType: 'futuresRecordService', recordName: 'futuresPitcherTrackManRecord',
                seasons: dateObj['season'],
                groupingColumn: 'ballType',
                authToken:JSON.stringify(cookies['hiball_token']),
            }
    
            let leagueHandPitchPromise = new Promise((resolve, reject) => {
                axios({
                    url : `${process.env.REACT_APP_API_URL}`,
                    params: {
                        ...pitchParam,
                        pitchingHands: pitchingHand,
                        gameTypeCode: 4201,
                    }
                }).then((result) => {
                    resolve(result);
                });
            });
    
            let pitchPromise = new Promise((resolve, reject) => {
                axios({
                    url : `${process.env.REACT_APP_API_URL}`,
                    params: {
                        ...pitchParam,
                        pitcherIds: profile['playerId'],
                        gameTypeCode: gameTypeCode
                    }
                }).then((result) => {
                    resolve(result);
                });
            });
    
            Promise.all([
                trackmanPromise, leagueHandPitchPromise, pitchPromise
            ]).then((response) => {
                setLoading(true);
                let record = _.shuffle(response[0]['data']['result']['record']);
                let pitchRecord = response[1]['data']['result'];
                let playerAvgRecord = response[2]['data']['result'];

                let indexedLeaguePitch = _.keyBy(pitchRecord, (item, idx) => {
                    if(item['taggedPitchType'] === 'Splitter') {
                        item['taggedPitchType'] = 'Forkball';
                    }

                    return item['taggedPitchType'];
                });
    
                let playerTotalCnt = 0;
                let indexedPlayerPitch = _.keyBy(playerAvgRecord, (item, idx) => {
                    playerTotalCnt += item['totalPitch']*1;
                    if(item['taggedPitchType'] === 'Changeup') {
                        return 'ChangeUp';
                    } else if(item['taggedPitchType'] === 'Two-Seamer(Sinker)') {
                        return 'Sinker';
                    } else if(item['taggedPitchType'] === 'Splitter') {
                        return 'Forkball'
                    } else {
                        return item['taggedPitchType'];
                    }    
                });

                let filterRecord = _.filter(record, (item) => {
                    item['calcHorzBreak'] = (item['horzBreak'])*173/80;
                    item['calcInducedVertBreak'] = -(item['inducedVertBreak'])*173/80;
                    item['key'] = (item['gameInfoId']+"_"+item['batterId']+"_"+item['pitcherId']+"_"
                        +item['strikes']+"_"+item['balls']+"_"+item['inning']+"_"+item['outs']+"_"+item['pitchOfPa']);

                    if(item['taggedPitchType'] === 'Splitter') {
                        item['taggedPitchType'] = 'Forkball';
                    }

                    if(item['taggedPitchType'] && item['horzBreak']) {
                        item['color'] = ballCodeObj[item['taggedPitchType']]['color'];
                        item['strokeColor'] = ballCodeObj[item['taggedPitchType']]['strokeColor'];
                    }

                    return item['taggedPitchType'] && item['horzBreak'];
                });
    
                let groupBall = _.groupBy(filterRecord, item => item['taggedPitchType']);
    
                let pitchInfoArr = [];
                let pitchDataArr = [];
                let ellipseDataArr = [];
                let avgDataArr = [];

                delete groupBall['Other'];
    
                _.each(groupBall, (item, idx) => {
                    let ballObj = ballCodeObj[idx];
                    let avgBallObj = indexedLeaguePitch[idx];
                    let playerAvgBallObj = indexedPlayerPitch[idx];
                    let avgQuantilData = _.find(ballCodeQuantile[pitchingHand], (item) => item['ballName'] == idx);
    
                    if(ballObj && playerAvgBallObj) {
                        let color = ballObj['color'];
                        let strokeColor = ballObj['strokeColor'];
                        let short = ballObj['short'];
                        let ballName = idx;
                        let pitchCnt = item['length'];
    
                        let avgHandTypeSpeed = avgBallObj['avgRelSpeed'];
                        let playerAvgSpeed = playerAvgBallObj['avgRelSpeed'];
                        let ballTypeCnt = playerAvgBallObj['totalPitch'];

                        let pitchRate = ((ballTypeCnt/playerTotalCnt)*100).toFixed(0);
                        let tmpObj = {
                            ballName, pitchCnt, color, pitchRate, strokeColor, short,
                            avgHandTypeSpeed, playerAvgSpeed
                        };

                        pitchInfoArr.push(tmpObj);

                        let originItem = _.clone(item);

                        if(toggle && (playerTotalCnt > 100)) {
                            item = item.slice(0, pitchRate);
                        }

                        if(pitchToggle) { // pitchByPitch
                            _.each(item, (innerData) => {
                                pitchDataArr.push(innerData);
                            });
                        } else { //eclipseData
                            let quantileObj = quantileFunc(originItem);
                            quantileObj['strokeColor'] = strokeColor;
                            quantileObj['color'] = color;

                            ellipseDataArr.push(quantileObj);
                        }

                        // let {horz_12, horz_87, induced_12, induced_87} = avgQuantilData;
                        let horz_12 = avgQuantilData['horz_12']*173/80;
                        let horz_87 = avgQuantilData['horz_87']*173/80;
                        let induced_12 = avgQuantilData['induced_12']*173/80;
                        let induced_87 = avgQuantilData['induced_87']*173/80;
                        let horzMiddle = ((horz_12 + horz_87)/2).toFixed(1);
                        let inducedMiddle = ((induced_12 + induced_87)/2).toFixed(1);

                        avgQuantilData['color'] = color;
                        avgQuantilData['strokeColor'] = strokeColor;
                        avgQuantilData['horzMiddle'] = horzMiddle;
                        avgQuantilData['inducedMiddle'] = inducedMiddle;

                        avgDataArr.push(avgQuantilData);
                    }
                });

                let sortedPitchArr = _.sortBy(pitchInfoArr, 'pitchCnt').reverse().slice(0, 5);
    
                setRecordObj((prevState) => {
                    return {
                        ...prevState,
                        sortedArr: sortedPitchArr,
                        pitchDataArr: pitchDataArr,
                        ellipseDataArr: ellipseDataArr,
                        avgDataArr: avgDataArr
                    }
                })
            });
        }
    }, [toggle, pitchToggle]);

    const quantileFunc = (dataArr) => {
        let horzBreakSorted = dataArr.sort(function (a, b) {
            return d3.ascending(a['calcHorzBreak'] * 1, b['calcHorzBreak'] * 1);
        });

        const horzValueArr = horzBreakSorted.map(d => d['calcHorzBreak']);

        const horzBreakQ1 = d3.quantile(horzValueArr, 0.125);
        const horzBreakQ3 = d3.quantile(horzValueArr, 0.875);
        const horzBreakMiddle = ((horzBreakQ1+horzBreakQ3)/2).toFixed(1);

        let inducedVertBreakSorted = dataArr.sort(function (a, b) {
            return d3.ascending(a['calcInducedVertBreak'] * 1, b['calcInducedVertBreak'] * 1);
        });

        const inducedVertValueArr = inducedVertBreakSorted.map(d => d['calcInducedVertBreak']);

        const inducedVertBreakQ1 = d3.quantile(inducedVertValueArr, 0.25);
        const inducedVertBreakQ3 = d3.quantile(inducedVertValueArr, 0.75);
        const inducedVertBreakMiddle = ((inducedVertBreakQ1+inducedVertBreakQ3)/2).toFixed(1);

        return {
            horzBreakQ1,
            horzBreakQ3,
            horzBreakMiddle,
            inducedVertBreakQ1,
            inducedVertBreakQ3,
            inducedVertBreakMiddle
        }
    }

    useEffect(() => {
        const svg = d3.select(svgRef.current);
        svg.selectAll(".league-average").remove();
        if(avgToggle) {
            let avgEllipseSvg = svg.select(".league-movement-wrapper")
                .selectAll("g")
                .data(recordObj['avgDataArr'])
                .join("g")
                .attr("class", "league-average")
                .attr("transform", (item) => {
                    return `translate(${item['horzMiddle']}, ${-item['inducedMiddle']})`
                })
                .attr("opacity", 0.8)

            let patternSvg = avgEllipseSvg.append("pattern")
            .attr("id", (item) => {
                return "diagonal-hatches-"+item['ballName'];
            })
            .attr("patternUnits", "userSpaceOnUse")
            .attr("width", 6)
            .attr("height", 6)

            patternSvg.append("rect")
            .attr("width", 6)
            .attr("height", 6)
            .attr('fill', (item) => {
                return item['color'];
            })
            .attr("opacity", 0.1);

            patternSvg.append("path")
            .attr("class", "hatch-pattern")
            .attr("d", "M -3, 3 L 3, -3 M 0, 6 L 6, 0 M 3, 9 L 9, 3")
            .style("stroke", (item) => {
                return item['strokeColor'];
            })
            .style("stroke-width", 0.75)

            avgEllipseSvg.append("ellipse")
            .attr("fill", (item) => {
                return "url(#diagonal-hatches-"+item['ballName']+")";
            })
            .attr("rx", item => Math.abs(item['horz_12']-item['horz_87']))
            .attr("ry", item => Math.abs(item['induced_12']-item['induced_87']))
        }

        // <g className="league-average league-average-sl" transform="translate(-34.599999999999994, -13.856018516916663)" opacity="0.8">
        //     <pattern id="diagonal-hatches-sl" patternUnits="userSpaceOnUse" width="6" height="6">
        //         <rect width="6" height="6" fill="#C3BD0E" opacity="0.1"></rect>
        //         <path className="hatch-pattern" d="M -3, 3 L 3, -3 M 0, 6 L 6, 0 M 3, 9 L 9, 3" style={{stroke: 'rgb(195, 189, 14)',strokeWidth: 0.75}}></path>
        //     </pattern>
        //     <ellipse fill="url(#diagonal-hatches-sl)" rx="27.99616297112499" ry="34.37188818291665"></ellipse>
        // </g>
    }, [recordObj, avgToggle]);

    useEffect(() => {
        const svg = d3.select(svgRef.current);
        svg.selectAll(".summary-circle").remove();
        svg.selectAll(".background-point").remove();

        if(pitchToggle) { // pitch by pitch
            svg.select(".bubble-wrapper")
                .selectAll("g")
                .data(recordObj['pitchDataArr'])
                .join("g")
                .attr("class", "background-point")
                .attr("transform", (item) => {
                    return `translate(${item['calcHorzBreak']}, ${item['calcInducedVertBreak']})`
                })
                .attr("opacity", 0.8)
                .append("circle")
                .attr("fill", (item, idx) => {
                    return item['color'];
                })
                .attr("stroke", (item, idx) => item['strokeColor'])
                .attr("stroke-width", 0.75)
                .attr("r", 6)
        } else { // ellipse
            let ellipseSvg = svg.select(".proportional-wrapper")
                .selectAll("g")
                .data(recordObj['ellipseDataArr'])
                .join("g")
                .attr("class", "summary-circle")
                .attr("transform", (item) => {
                    return `translate(${item['horzBreakMiddle']}, ${item['inducedVertBreakMiddle']})`
                })
                .attr("opacity", 0.8)
            
            ellipseSvg.append("ellipse")
                .attr("class", "proportional")
                .attr('fill', (item) => {
                    return item['color'];
                })
                .attr("stroke", item => item['strokeColor'])
                .attr("stroke-width", 1)
                .attr("fill-opacity", 1)
                .attr("rx", item => Math.abs(item['horzBreakQ1']-item['horzBreakQ3']))
                .attr("ry", item => Math.abs(item['inducedVertBreakQ1']-item['inducedVertBreakQ3']))

            ellipseSvg.append("circle")
                .attr("class", "proportional-center")
                .attr('fill', (item) => {
                    return item['strokeColor'];
                })
                .attr('r', 3);
                
        }
    }, [recordObj]);

    const toggleHandler = () => {
        setToggle(!toggle);
    }

    const avgToggleHandler = () => {
        setAvgToggle(!avgToggle);
    }

    const pitchToggleHandler = () => {
        setPitchToggle(!pitchToggle);
    }

    return (
    <>
    <div className="boxTitle">구종별 무브먼트</div>
    <div style={{display: 'flex', padding: '0px 5px', justifyContent: 'space-around'}}>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <span style={{fontSize: '12px'}}>표본 100구</span>
            <Switch
            onColor="#399098"
            checked={toggle}
            onChange={toggleHandler}
            width={35}
            height={18}
            />
        </div>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <span style={{fontSize: '12px'}}>KBO평균</span>
            <Switch
            onColor="#399098"
            checked={avgToggle}
            onChange={avgToggleHandler}
            width={35}
            height={18}
            />
        </div>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <span style={{fontSize: '12px'}}>개별투구표시</span>
            <Switch
            onColor="#399098"
            checked={pitchToggle}
            onChange={pitchToggleHandler}
            width={35}
            height={18}
            />
        </div>
    </div>
    {
    loading ?
    <>
    <svg id="viz" height="311" style={{display: 'block', margin: '0 6px', width: 'calc(100% - 12px)'}} viewBox="0 0 400 530" ref={svgRef}>
        <g id="polar-viz" transform="translate(0, 30)">
            <circle r="185" fill="#E4F2F5" cx="200" cy="185"></circle>
            <circle className="tick" cx="200" cy="185" r="43.25" fill="none" stroke="rgb(95, 134, 153)" strokeWidth="0.6" strokeDasharray="3"></circle>
            <circle className="tick" cx="200" cy="185" r="86.5" fill="none" stroke="rgb(95, 134, 153)" strokeWidth="0.6" strokeDasharray=""></circle>
            <circle className="tick" cx="200" cy="185" r="129.75" fill="none" stroke="rgb(95, 134, 153)" strokeWidth="0.6" strokeDasharray="3"></circle>
            <circle className="tick" cx="200" cy="185" r="173" fill="none" stroke="rgb(95, 134, 153)" strokeWidth="0.6" strokeDasharray=""></circle>
            <path d="M200,-5L200,390" fill="none" stroke="rgb(95, 134, 153)" strokeWidth="0.6"></path>
            <path d="M0,185L400,185" fill="none" stroke="rgb(95, 134, 153)" strokeWidth="0.6"></path>
            <text fontSize="12" className="pitch-movement-label right-label" transform="translate(200,185)" x="82.5" y="-4" textAnchor="end" fill="rgb(89, 91, 92)">40cm</text>
            <text fontSize="12" className="pitch-movement-label right-label" transform="translate(200,185)" x="169" y="-4" textAnchor="end" fill="rgb(95, 134, 153)">80cm</text>
            <text fontSize="12" className="pitch-movement-label left-label" transform="translate(200,185)" x="-39.25" y="-4" textAnchor="start" fill="rgb(95, 134, 153)">20cm</text>
            <text fontSize="12" className="pitch-movement-label left-label" transform="translate(200,185)" x="-82.5" y="-4" textAnchor="start" fill="rgb(95, 134, 153)">40cm</text>
            <text fontSize="12" className="pitch-movement-label left-label" transform="translate(200,185)" x="-125.75" y="-4" textAnchor="start" fill="rgb(95, 134, 153)">60cm</text>
            <text fontSize="12" className="pitch-movement-label left-label" transform="translate(200,185)" x="-169" y="-4" textAnchor="start" fill="rgb(95, 134, 153)">80cm</text>
            <text fontSize="12" className="pitch-movement-label top-label" transform="translate(200,185)" y="-90.5" x="2" dominantBaseline="auto" textAnchor="start" fill="rgb(95, 134, 153)">40cm</text>
            <text fontSize="12" className="pitch-movement-label top-label" transform="translate(200,185)" y="-169" x="2" dominantBaseline="hanging" textAnchor="start" fill="rgb(95, 134, 153)">80cm</text>
            <text fontSize="12" className="pitch-movement-label bottom-label" transform="translate(200,185)" y="82.5" x="2" textAnchor="start" fill="rgb(95, 134, 153)">40cm</text>
            <text fontSize="12" className="pitch-movement-label bottom-label" transform="translate(200,185)" y="169" x="2" textAnchor="start" fill="rgb(95, 134, 153)">80cm</text>
            {/* <g className="title" transform="translate(0,0)">
                <text fontSize="24" textAnchor="start" fill="#000" stroke="#000">구종별 무브먼트</text>
            </g> */}
            <g className="title" transform="translate(0,55)">
                <text fontSize="15" textAnchor="start" x="15" fill="#000">상하</text>
                <text fontSize="15" textAnchor="start" y="15" fill="#000">수직무브</text>
            </g>
            <g className="title" transform="translate(40,370)">
                <text fontSize="15" textAnchor="start" x="15" fill="#000">좌우</text>
                <text fontSize="15" textAnchor="start" y="15" fill="#000">수평무브</text>
            </g>
            <g className="wrapper" transform="translate(200,185)">
                <g className="league-movement-wrapper">
                    <g className="league-average league-average-sl" transform="translate(-34.599999999999994, -13.856018516916663)" opacity="0.8">
                        <pattern id="diagonal-hatches-sl" patternUnits="userSpaceOnUse" width="6" height="6">
                            <rect width="6" height="6" fill="#C3BD0E" opacity="0.1"></rect>
                            <path className="hatch-pattern" d="M -3, 3 L 3, -3 M 0, 6 L 6, 0 M 3, 9 L 9, 3" style={{stroke: 'rgb(195, 189, 14)',strokeWidth: 0.75}}></path>
                        </pattern>
                        <ellipse fill="url(#diagonal-hatches-sl)" rx="27.99616297112499" ry="34.37188818291665"></ellipse>
                    </g>
                    <g className="league-average league-average-si" transform="translate(111.00833333333333, -62.51404271841668)" opacity="0.8">
                        <pattern id="diagonal-hatches-si" patternUnits="userSpaceOnUse" width="6" height="6">
                            <rect width="6" height="6" fill="#FE9D00" opacity="0.1"></rect>
                            <path className="hatch-pattern" d="M -3, 3 L 3, -3 M 0, 6 L 6, 0 M 3, 9 L 9, 3" style={{stroke: 'rgb(254, 157, 0)',strokeWidth: 0.75}}></path>
                        </pattern>
                        <ellipse fill="url(#diagonal-hatches-si)" rx="27.912920741333323" ry="30.378311620999995"></ellipse>
                    </g>
                    <g className="league-average league-average-cu" transform="translate(-68.47916666666666, 71.72459302225002)" opacity="0.8">
                        <pattern id="diagonal-hatches-cu" patternUnits="userSpaceOnUse" width="6" height="6">
                            <rect width="6" height="6" fill="#00D1ED" opacity="0.1"></rect>
                            <path className="hatch-pattern" d="M -3, 3 L 3, -3 M 0, 6 L 6, 0 M 3, 9 L 9, 3" style={{stroke: 'rgb(0, 209, 237)', strokeWidth: 0.75}}></path>
                        </pattern>
                        <ellipse fill="url(#diagonal-hatches-cu)" rx="30.261463225749992" ry="33.994229262208336"></ellipse>
                    </g>
                    <g className="league-average league-average-fc" transform="translate(-16.57916666666668, -57.17502136900001)" opacity="0.8">
                        <pattern id="diagonal-hatches-fc" patternUnits="userSpaceOnUse" width="6" height="6">
                            <rect width="6" height="6" fill="#933F2C" opacity="0.1"></rect>
                            <path className="hatch-pattern" d="M -3, 3 L 3, -3 M 0, 6 L 6, 0 M 3, 9 L 9, 3" style={{stroke: 'rgb(147, 63, 44)', strokeWidth: 0.75}}></path>
                        </pattern>
                        <ellipse fill="url(#diagonal-hatches-fc)" rx="29.169219025291653" ry="32.99982547845832"></ellipse>
                    </g>
                    <g className="league-average league-average-ff" transform="translate(55.50416666666666, -111.48548069037497)" opacity="0.8">
                        <pattern id="diagonal-hatches-ff" patternUnits="userSpaceOnUse" width="6" height="6">
                            <rect width="6" height="6" fill="#D22D49" opacity="0.1"></rect>
                            <path className="hatch-pattern" d="M -3, 3 L 3, -3 M 0, 6 L 6, 0 M 3, 9 L 9, 3" style={{stroke: 'rgb(210, 45, 73)', strokeWidth: 0.75}}></path>
                        </pattern>
                        <ellipse fill="url(#diagonal-hatches-ff)" rx="27.50322420291664" ry="26.00320436233332"></ellipse>
                    </g>
                </g>
                <g className="bubble-wrapper">
                {/* {
                _.map(recordObj['groupData'], (ballDataArr, idx) => (
                    _.map(ballDataArr, (item) => (
                        <g key={item['key']} className="pitch-bubbles" transform={`translate(${item['calcHorzBreak']}, ${item['calcInducedVertBreak']})`} opacity="0.8" data-year="2025">
                            <circle fill={`${ballCodeObj[idx]['color']}`} stroke={`${ballCodeObj[idx]['strokeColor']}`} strokeWidth="0.75" r="6" style={{cursor: 'pointer'}}></circle>
                        </g>
                    ))
                ))
                } */}
                </g>
                {/* <g className="background-arm" opacity="0">
                    <path className="background-arm-path" fill="black" fillOpacity="0.5" d="M-2.604545235657253,-7.564148604794535L2.604545235657254,7.564148604794534L123.33217149292568,-40.35143088961744L122.02989887509705,-44.1335051920147"></path>
                    <path className="background-arm-bottom" fill="black" fillOpacity="0.5" d="M -2.604545235657253,-7.564148604794535 A 8 8 0 1 0 2.604545235657254,7.564148604794534"></path>
                    <circle r="7" fill="white" stroke="black" strokeWidth="2.5" strokeOpacity="0.5" cx="122.68103518401136" cy="-42.24246804081607"></circle>
                </g> */}
                <g className="bubble-average-wrapper" style={{pointerEvents: 'none'}}>
                    <g className="bubble-average" transform="translate(66.31666666666666, -67.75833333333333)" opacity="0">
                        <g className="tooltip-wrapper" opacity="0">
                            <path className="summary-x-line" d="M0,0L0,67.75833333333333" stroke="rgb(137, 29, 48)" strokeWidth="1.5"></path>
                            <path className="summary-y-line" d="M0,0L-66.31666666666666,0" stroke="rgb(137, 29, 48)" strokeWidth="1.5"></path>
                            <g className="break-tooltip" transform="translate(0, 80.75833333333333)">
                                <circle className="break-tooltip-circle" r="10" fill="rgb(243, 255, 255)" strokeWidth="0"></circle>
                                <rect className="break-tooltip-rect" width="84.92462311557789" height="20" y="-10" fill="rgb(243, 255, 255)" strokeWidth="0" transform="rotate(30)"></rect>
                                <text className="break-tooltip-text" fill="#999" fontSize="12" fontWeight="bold" dominantBaseline="middle" dy="0" dx="0" transform="rotate(30)">9.2 INCHES TAIL</text>
                            </g>
                            <g className="vert-tooltip" transform="translate(-79.31666666666666, 0)" width="85.56846733668341">
                                <circle className="break-tooltip-circle" r="10" fill="rgb(243, 255, 255)" strokeWidth="0"></circle>
                                <rect className="break-tooltip-rect" width="85.56846733668341" height="20" y="-10" fill="rgb(243, 255, 255)" strokeWidth="0" transform="rotate(-150)"></rect>
                                <text fill="#999" fontSize="12" fontWeight="bold" dominantBaseline="middle" dy="0" dx="0" textAnchor="end" transform="rotate(30)">9.4 INCHES RISE</text>
                            </g>
                        </g>
                        <circle className="bubble-average-center" r="3.4782608695652173" fill="rgba(255, 255, 255, 0.9)" stroke="rgb(137, 29, 48)" strokeWidth="2"></circle>
                        <text className="bubble-average-center-avg" textAnchor="middle" dominantBaseline="middle" fill="#D22D49" dy="1" fontSize="12"></text>
                    </g>
                    <g className="bubble-average" transform="translate(6.487499999999997, -69.92083333333335)" opacity="0">
                        <g className="tooltip-wrapper" opacity="0">
                            <path className="summary-x-line" d="M0,0L0,69.92083333333335" stroke="rgb(96, 41, 29)" strokeWidth="1.5"></path>
                            <path className="summary-y-line" d="M0,0L-6.487499999999997,0" stroke="rgb(96, 41, 29)" strokeWidth="1.5"></path>
                            <g className="break-tooltip" transform="translate(0, 82.92083333333335)">
                                <circle className="break-tooltip-circle" r="10" fill="rgb(243, 255, 255)" strokeWidth="0"></circle>
                                <rect className="break-tooltip-rect" width="84.92462311557789" height="20" y="-10" fill="rgb(243, 255, 255)" strokeWidth="0" transform="rotate(30)"></rect>
                                <text className="break-tooltip-text" fill="#999" fontSize="12" fontWeight="bold" dominantBaseline="middle" dy="0" dx="0" transform="rotate(30)">0.9 INCHES TAIL</text>
                            </g>
                            <g className="vert-tooltip" transform="translate(-19.73562321079551, 0)" width="85.56846733668341">
                                <circle className="break-tooltip-circle" r="10" fill="rgb(243, 255, 255)" strokeWidth="0"></circle>
                                <rect className="break-tooltip-rect" width="85.56846733668341" height="20" y="-10" fill="rgb(243, 255, 255)" strokeWidth="0" transform="rotate(-150)"></rect>
                                <text fill="#999" fontSize="12" fontWeight="bold" dominantBaseline="middle" dy="0" dx="0" textAnchor="end" transform="rotate(30)">9.7 INCHES RISE</text>
                            </g>
                        </g>
                        <circle className="bubble-average-center" r="6.735623210795508" fill="rgba(255, 255, 255, 0.9)" stroke="rgb(96, 41, 29)" strokeWidth="2"></circle>
                        <text className="bubble-average-center-avg" textAnchor="middle" dominantBaseline="middle" fill="#933F2C" dy="1" fontSize="12"></text>
                    </g>
                    <g className="bubble-average" transform="translate(-114.61249999999997, 63.43333333333334)" opacity="0">
                        <g className="tooltip-wrapper" opacity="0">
                            <path className="summary-x-line" d="M0,0L0,-63.43333333333334" stroke="rgb(0, 136, 154)" strokeWidth="1.5"></path>
                            <path className="summary-y-line" d="M0,0L114.61249999999997,0" stroke="rgb(0, 136, 154)" strokeWidth="1.5"></path>
                            <g className="break-tooltip" transform="translate(0, -76.43333333333334)">
                                <circle className="break-tooltip-circle" r="10" fill="rgb(243, 255, 255)" strokeWidth="0"></circle>
                                <rect className="break-tooltip-rect" width="102.47281328517587" height="20" y="-10" fill="rgb(243, 255, 255)" strokeWidth="0" transform="rotate(-30)"></rect>
                                <text className="break-tooltip-text" fill="#999" fontSize="12" fontWeight="bold" dominantBaseline="middle" dy="0" dx="0" transform="rotate(-30)">15.9 INCHES BREAK</text>
                            </g>
                            <g className="vert-tooltip" transform="translate(127.61249999999997, 0)" width="90.78203517587939">
                                <circle className="break-tooltip-circle" r="10" fill="rgb(243, 255, 255)" strokeWidth="0"></circle>
                                <rect className="break-tooltip-rect" width="90.78203517587939" height="20" y="-10" fill="rgb(243, 255, 255)" strokeWidth="0" transform="rotate(30)"></rect>
                                <text fill="#999" fontSize="12" fontWeight="bold" dominantBaseline="middle" dy="0" dx="0" textAnchor="start" transform="rotate(30)">8.8 INCHES DROP</text>
                            </g>
                        </g>
                        <circle className="bubble-average-center" r="18.48721010910374" fill="rgba(255, 255, 255, 0.9)" stroke="rgb(0, 136, 154)" strokeWidth="2"></circle>
                        <text className="bubble-average-center-avg" textAnchor="middle" dominantBaseline="middle" fill="#00D1ED" dy="1" fontSize="12">AVG</text>
                    </g>
                    <g className="bubble-average" transform="translate(81.45416666666665, -0.7208333333333314)" opacity="0">
                        <g className="tooltip-wrapper" opacity="0">
                            <path className="summary-x-line" d="M0,0L0,0.7208333333333314" stroke="rgb(166, 102, 0)" strokeWidth="1.5"></path>
                            <path className="summary-y-line" d="M0,0L-81.45416666666665,0" stroke="rgb(166, 102, 0)" strokeWidth="1.5"></path>
                            <g className="break-tooltip" transform="translate(0, 36.97225869928734 )">
                                <circle className="break-tooltip-circle" r="10" fill="rgb(243, 255, 255)" strokeWidth="0"></circle>
                                <rect className="break-tooltip-rect" width="90.9861809045226" height="20" y="-10" fill="rgb(243, 255, 255)" strokeWidth="0" transform="rotate(30)"></rect>
                                <text className="break-tooltip-text" fill="#999" fontSize="12" fontWeight="bold" dominantBaseline="middle" dy="0" dx="0" transform="rotate(30)">11.3 INCHES TAIL</text>
                            </g>
                            <g className="vert-tooltip" transform="translate(-94.45416666666665, 0)" width="85.56846733668341">
                                <circle className="break-tooltip-circle" r="10" fill="rgb(243, 255, 255)" strokeWidth="0"></circle>
                                <rect className="break-tooltip-rect" width="85.56846733668341" height="20" y="-10" fill="rgb(243, 255, 255)" strokeWidth="0" transform="rotate(-150)"></rect>
                                <text fill="#999" fontSize="12" fontWeight="bold" dominantBaseline="middle" dy="0" dx="0" textAnchor="end" transform="rotate(30)">0.1 INCHES RISE</text>
                            </g>
                        </g>
                        <circle className="bubble-average-center" r="23.97225869928734" fill="rgba(255, 255, 255, 0.9)" stroke="rgb(166, 102, 0)" strokeWidth="2"></circle>
                        <text className="bubble-average-center-avg" textAnchor="middle" dominantBaseline="middle" fill="#FE9D00" dy="1" fontSize="12">AVG</text>
                    </g>
                    <g className="bubble-average" transform="translate(-99.47499999999998, -41.087500000000006)" opacity="0">
                        <g className="tooltip-wrapper" opacity="0">
                            <path className="summary-x-line" d="M0,0L0,41.087500000000006" stroke="rgb(127, 123, 9)" strokeWidth="1.5"></path>
                            <path className="summary-y-line" d="M0,0L99.47499999999998,0" stroke="rgb(127, 123, 9)" strokeWidth="1.5"></path>
                            <g className="break-tooltip" transform="translate(0, 54.087500000000006)">
                                <circle className="break-tooltip-circle" r="10" fill="rgb(243, 255, 255)" strokeWidth="0"></circle>
                                <rect className="break-tooltip-rect" width="102.47281328517587" height="20" y="-10" fill="rgb(243, 255, 255)" strokeWidth="0" transform="rotate(30)"></rect>
                                <text className="break-tooltip-text" fill="#999" fontSize="12" fontWeight="bold" dominantBaseline="middle" dy="0" dx="0" transform="rotate(30)">13.8 INCHES BREAK</text>
                            </g>
                            <g className="vert-tooltip" transform="translate(112.47499999999998, 0)" width="85.56846733668341">
                                <circle className="break-tooltip-circle" r="10" fill="rgb(243, 255, 255)" strokeWidth="0"></circle>
                                <rect className="break-tooltip-rect" width="85.56846733668341" height="20" y="-10" fill="rgb(243, 255, 255)" strokeWidth="0" transform="rotate(30)"></rect>
                                <text fill="#999" fontSize="12" fontWeight="bold" dominantBaseline="middle" dy="0" dx="0" textAnchor="start" transform="rotate(30)">5.7 INCHES RISE</text>
                            </g>
                        </g>
                        <circle className="bubble-average-center" r="25.02172968684897" fill="rgba(255, 255, 255, 0.9)" stroke="rgb(127, 123, 9)" strokeWidth="2"></circle>
                        <text className="bubble-average-center-avg" textAnchor="middle" dominantBaseline="middle" fill="#C3BD0E" dy="1" fontSize="12">AVG</text>
                    </g>
                </g>
                <g className="proportional-wrapper">
                    {/* <g className="summary-circle summary-circle-ff" transform="translate(-26.67083333333332, -134.79583333333335)" opacity="0.8">
                        <circle className="proportional" fill="#D22D49" stroke="rgb(147, 31, 51)" strokeWidth="1" fillOpacity="1" r="26.84566361951989" opacity="1"></circle>
                        <circle className="proportional-center" fill="rgb(147, 31, 51)" r="3"></circle>
                    </g>
                    <g className="summary-circle summary-circle-si" transform="translate(-80.73333333333335, -123.26250000000003)" opacity="0.8">
                        <circle className="proportional" fill="#FE9D00" stroke="rgb(178, 110, 0)" strokeWidth="1" fillOpacity="1" r="22.360679774997898" opacity="1"></circle>
                        <circle className="proportional-center" fill="rgb(178, 110, 0)" r="3"></circle>
                    </g>
                    <g className="summary-circle summary-circle-sl" transform="translate(64.875, -42.52916666666667)" opacity="0.8">
                        <circle className="proportional" fill="#EEE716" stroke="rgb(167, 162, 15)" strokeWidth="1" fillOpacity="1" r="15.085960589122315" opacity="1"></circle>
                        <circle className="proportional-center" fill="rgb(167, 162, 15)" r="3"></circle>
                    </g>
                    <g className="summary-circle summary-circle-fs" transform="translate(-32.4375, -38.20416666666668)" opacity="0.8">
                        <circle className="proportional" fill="#3BACAC" stroke="rgb(41, 120, 120)" strokeWidth="1" fillOpacity="1" r="12.317635241028794" opacity="1"></circle>
                        <circle className="proportional-center" fill="rgb(41, 120, 120)" r="3"></circle>
                    </g> */}
                </g>
            </g>
            <g id="top-legend" transform="translate(200, 380)">
                <text textAnchor="end" fontSize="12" dx="-50" fill="rgb(104, 146, 162)">좌타석</text>
                <text textAnchor="start" fontSize="12" dx="50" fill="rgb(104, 146, 162)">우타석</text>
                <path d="M0,0L0,8L-7,4" fill="rgb(104, 146, 162)" transform="translate(-40, -8)"></path>
                <path d="M0,0L0,8L7,4" fill="rgb(104, 146, 162)" transform="translate(40, -8)"></path>
            </g>
            <g id="left-legend" transform="translate(0, 185)">
                <g transform="translate(0, -80)">
                    <text dy="10" fontSize="12" dominantBaseline="middle" fontFamily="Roboto Condensed" fill="rgb(104, 146, 162)">떠오름</text>
                    <path d="M0,7L8,7L4,0" fill="rgb(104, 146, 162)" transform="translate(2, 20)"></path>
                </g>
                <g transform="translate(0, 80)">
                    <text dy="-10" fontSize="12" dominantBaseline="middle" fontFamily="Roboto Condensed" fill="rgb(104, 146, 162)">가라앉음</text>
                    <path d="M0,0L8,0L4,7" fill="rgb(104, 146, 162)" transform="translate(2, -30)"></path>
                </g>
            </g>
            <g transform="translate(2, -12)" fontSize="10" opacity="0" style={{textTransform: 'uppercase'}}>
                <g>
                    <rect width="32" height="16" y="-12" fill="rgb(188, 196, 227)" stroke="rgb(0, 0, 0)" strokeWidth="0.5" strokeOpacity="0.2"></rect>
                    <text fontWeight="bold" fontSize="12" textAnchor="middle" x="17" fill="#000">4.1"</text>
                    <text x="34" fill="rgb(104, 146, 162)">less tail vs RHP</text>
                </g>
                <g transform="translate(0, 20)">
                    <rect width="32" height="16" y="-12" fill="rgb(226, 76, 66)" stroke="rgb(0, 0, 0)" strokeWidth="0.5" strokeOpacity="0.2"></rect>
                    <text x="34" fill="rgb(104, 146, 162)">more drop vs RHP</text>
                    <text fontWeight="bold" fontSize="12" textAnchor="middle" x="17" fill="#fff">7.2"</text>
                </g>
            </g>
        </g>
        <g id="dist-viz" transform={`translate(${(6-recordObj['sortedArr']['length'])*27.5}, 425)`}>
            <g>
                <text dominantBaseline="middle" y="44" fill="#399098" x="55" textAnchor="end">구사율</text>
                <text dominantBaseline="middle" fill="#399098" y="66" x="55" textAnchor="end">평균구속</text>
                <text dominantBaseline="middle" fill="#399098" y="88" x="55" textAnchor="end">1군{profile['pitchingHand'] === 'L' ? '좌투' : '우투'}평균</text>
            </g>
            <g transform="translate(55,0)">
                {
                _.map(recordObj['sortedArr'], (ballInfo, idx) => (
                    <g className="dist-info" opacity="0.8" transform={`translate(${idx*60}, 0)`} style={{cursor: 'pointer',fontSize: '14px'}} key={ballInfo['ballName']}>
                        <line className="dotted" x1="10" x2="50" y1="32" y2="32" width="40" stroke="#49a" strokeWidth="2" strokeDasharray="3 3"></line>
                        <rect className="dist-pill" height="12" rx="6" ry="6" y="16" width="40" x="10" fill={ballInfo['color']} stroke={ballInfo['strokeColor']} strokeWidth="0.75"></rect>
                        <text className="dist-pitch-type" x="30" y="5" dominantBaseline="middle" textAnchor="middle">{ballInfo['short']}</text>
                        <text className="dist-percent" x="30" y="44" textAnchor="middle" dominantBaseline="middle">{ballInfo['pitchRate']}%</text>
                        <text className="dist-velo" x="30" y="66" textAnchor="middle" dominantBaseline="middle">{ballInfo['playerAvgSpeed']}</text>
                        <text className="dist-lg-velo" x="30" y="88" textAnchor="middle" dominantBaseline="middle">{ballInfo['avgHandTypeSpeed']}</text>
                    </g>
                ))
                }
            </g>
        </g>
    </svg>
    </>
    : <DefaultLoader />
    }
    
    </>
    )
}

export default MovementProfile;